import { Routes } from '@angular/router';
import { paymentRulesRedirect } from '../../../shared/payment-rules/payment-rules-redirects';
import { authGuard } from '../../../core/guards/auth.guard';
import { MOBILE_ABOUT_BENEFITS_ROUTES } from '../side-pages/about-benefits/about-benefits.routes';
import { MOBILE_ABOUT_INFO_ROUTES } from '../side-pages/about-info/about-info.routes';
import { MOBILE_EMPLOYEES_ROUTES } from '../employees/employees.routes';
import { MOBILE_MENU_ROUTES } from '../side-pages/menu/menu.routes';
import { MOBILE_FEEDBACK_ROUTES } from '../side-pages/feedback/feedback.routes';
import { residentRedirect } from '../../../shared/benefits-page/benefits-redirects';

export const NAV_ROUTES: Routes = [
  {
    path: 'my-auto',
    canActivate: [authGuard],
    loadComponent: () => import('../my-auto/my-auto.component').then(c => c.MyAutoComponent),
  },
  {
    path: 'sessions',
    data: { fullSheet: true },
    canActivate: [authGuard],
    loadComponent: () => import('../sessions/sessions.component').then(c => c.SessionsComponent),
  },
  {
    path: 'balance',
    canActivate: [authGuard],
    loadComponent: () => import('../balance/balance.component').then(c => c.BalanceComponent),
  },
  {
    path: 'subscriptions',
    canActivate: [authGuard],
    loadComponent: () =>
      import('../subscription/subscription.component').then(c => c.SubscriptionComponent),
  },
  {
    path: 'subscriptions-list',
    canActivate: [authGuard],
    loadComponent: () =>
      import('../subscription/subscription-buy-list/subscription-buy-list.component').then(
        c => c.SubscriptionBuyListComponent,
      ),
  },
  {
    path: 'notifications',
    canActivate: [authGuard],
    loadComponent: () =>
      import('../notifications/notifications.component').then(c => c.NotificationsComponent),
  },
  {
    path: 'history',
    canActivate: [authGuard],
    loadComponent: () => import('../history/history.component').then(c => c.HistoryComponent),
  },
  {
    path: 'payment-cards',
    canActivate: [authGuard],
    loadComponent: () =>
      import('../payment-cards/payment-cards.component').then(c => c.PaymentCardsComponent),
  },
  {
    path: 'settings',
    loadComponent: () => import('../settings/settings.component').then(c => c.SettingsComponent),
  },
  {
    path: 'employees',
    loadComponent: () =>
      import('../employees/employees.component').then(c => c.EmployeesPageComponent),
    children: [...MOBILE_EMPLOYEES_ROUTES],
  },
  {
    path: 'about-info',
    loadComponent: () =>
      import('../side-pages/about-info/about-info.component').then(c => c.AboutInfoComponent),
    children: [...MOBILE_ABOUT_INFO_ROUTES],
  },
  {
    path: 'tariffs',
    loadComponent: () =>
      import('../side-pages/tariffs/tariffs.component').then(c => c.TariffsComponent),
  },
  // Оплата и штрафы — одна страница payment-rules (прототип 1a); старые адреса редиректят на вкладки.
  { path: 'about-payments', pathMatch: 'full', redirectTo: 'payment-rules' },
  {
    path: 'about-payments/mobile',
    pathMatch: 'full',
    redirectTo: paymentRulesRedirect('mobile', 'app'),
  },
  { path: 'about-fines', pathMatch: 'full', redirectTo: paymentRulesRedirect('mobile', 'fines') },
  {
    path: 'payment-rules',
    loadComponent: () =>
      import('../side-pages/payment-rules/payment-rules.component').then(
        c => c.PaymentRulesPageComponent,
      ),
  },
  {
    path: 'about-benefits/citizens',
    pathMatch: 'full',
    redirectTo: 'about-benefits',
  },
  {
    path: 'about-benefits/online-application',
    pathMatch: 'full',
    redirectTo: 'about-benefits',
  },
  { path: 'about-residents', pathMatch: 'full', redirectTo: residentRedirect('mobile') },
  {
    path: 'about-residents/resident-abonement',
    pathMatch: 'full',
    redirectTo: residentRedirect('mobile'),
  },
  // Льготы — одна страница about-benefits (UIMSP-1450); старые адреса хаба и категорий редиректят на неё.
  {
    path: 'about-benefits',
    loadComponent: () =>
      import('../side-pages/about-benefits/about-benefits.component').then(
        c => c.AboutBenefitsComponent,
      ),
    children: [...MOBILE_ABOUT_BENEFITS_ROUTES],
  },
  {
    path: 'menu',
    children: [...MOBILE_MENU_ROUTES],
  },
  {
    path: 'feedback',
    data: { hideNavBar: true },
    canActivate: [authGuard],
    loadComponent: () =>
      import('../side-pages/feedback/feedback-page.component').then(c => c.FeedbackPageComponent),
    children: [...MOBILE_FEEDBACK_ROUTES],
  },
  {
    path: 'faq',
    loadComponent: () => import('../side-pages/faq/faq.component').then(c => c.FaqComponent),
  },
];
